// src/pages/ActivitiesPage.js
import React, { useContext, useEffect } from "react";
import { ContentContext } from "../context/ContentProvider";
import { Helmet } from "react-helmet";
import "./Activities.css";

function Activities() {
  const { content } = useContext(ContentContext);
  

  // Debug: log whenever content changes
  useEffect(() => {
    console.log("Updated activities content:", content);
  }, [content]);

  return (
    <>
      <Helmet>
        <title>Activities | Londonhouse </title>
      </Helmet>
      <div className="activities-page-container">
        <div className="activities-content">
          <h1>Activities</h1>
          <div
            className="activities-text"
            dangerouslySetInnerHTML={{
              __html: content.activitiesText || "No activities content available."
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Activities;
